import { useState } from "react";
import { openSignedDocument } from "@/lib/documents";
import { ExternalLink } from "lucide-react";
import { toast } from "sonner";

/**
 * Renders a link/button that opens a document via a short-lived signed URL.
 * Uses <button> semantics but styled like an anchor.
 */
export default function DocumentLink({ docId, label = "Open", testid, className = "" }) {
  const [busy, setBusy] = useState(false);
  const onClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await openSignedDocument(docId);
    } catch (_e) {
      toast.error("Could not open document");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid || `open-doc-${docId}`}
      disabled={busy}
      className={`inline-flex items-center gap-1 text-teal-700 hover:text-teal-800 font-semibold text-sm disabled:opacity-60 ${className}`}
    >
      {busy ? "Opening…" : label} <ExternalLink className="h-3 w-3" />
    </button>
  );
}
